module.exports = __webpack_public_path__ + "44b96d1f1d90eed8ff12457bc298df18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/broadcom_2022_chart.png
// module id = 1644
// module chunks = 0